import {Injectable} from '@angular/core';
import {Graphql} from './graphql';
import {PmDto} from '../dto/pm-dto';
import {PmStatusSummaryDto} from '../dto/pm-status-summary-dto';

import {
  approvePm,
  createPm,
  removePm,
  retrievePmById,
  retrievePmsByEmployeeId,
  retrievePmsByEmployeeIdAndStatuses,
  retrievePmStatusSummary,
  submitPmFeedbackRequest, updatePmFeedbackExpiryDate,
  updatePm,
  createPmFeedback,
  retrievePmFeedback
} from '../graphql/pm.graphql';
import {PmStatus} from "../enum/pm-status";
import {PmFeedbackDto} from "../dto/pm-feedback-dto";

@Injectable({
  providedIn: 'root'
})
export class Pm extends Graphql {

  public retrievePmsByEmployeeId(employeeId: string, page: number, size: number, fields: string[] = ['id']) {
    return this.query<PmDto[]>(retrievePmsByEmployeeId(fields), {
      employeeId: employeeId,
      page: page,
      size: size
    }, "retrievePmsByEmployeeId");
  }

  public retrievePmsByUserId(userId: string, page: number, size: number, fields: string[] = ['id']) {
    return this.retrievePmsByEmployeeId(userId, page, size, fields);
  }

  public retrievePmsByEmployeeIdAndStatuses(employeeId: string, statuses: PmStatus[], fields: string[] = ['id']) {
    return this.query<PmDto[]>(retrievePmsByEmployeeIdAndStatuses(fields), {
      employeeId: employeeId,
      statuses: statuses,
    }, "retrievePmsByEmployeeIdAndStatuses");
  }

  public retrievePmById(id: string, fields: string[] = ['id']) {
    return this.query<PmDto>(retrievePmById(fields), {id: id}, "retrievePmById");
  }

  public createPm(pm: PmDto, fields: string[] = ['id']) {
    return this.mutation<PmDto>(createPm(fields), {pm: pm}, "createPm");
  }

  public updatePm(pm: PmDto, fields: string[] = ['id']) {
    return this.mutation<PmDto>(updatePm(fields), {pm: pm}, "updatePm");
  }

  public removePm(pmId: string) {
    return this.mutation<boolean>(removePm(), {pmId: pmId}, "removePm")
  }

  public retrievePmFeedback(pmId: string, fields: string[] = ['id']) {
    return this.query<PmFeedbackDto>(retrievePmFeedback(fields), {pmId: pmId}, "retrievePmFeedback")
  }

  public createPmFeedback(pmId: string, pmFeedback: PmFeedbackDto, fields: string[] = ['id']) {
    return this.mutation<PmFeedbackDto>(createPmFeedback(fields), {pmId: pmId, pmFeedback: pmFeedback}, "createPmFeedback")
  }

  public approvePm(pmId: string) {
    return this.mutation<boolean>(approvePm(), {pmId: pmId}, "approvePm")
  }

  public retrievePmStatusSummary(fields: string[] = ['totalEmployees', 'completed', 'open']) {
    return this.query<PmStatusSummaryDto>(
      retrievePmStatusSummary(fields),
      {},
      'retrievePmStatusSummary'
    );
  }

  public submitPmFeedbackRequest(pmId: string, feedbacks: PmFeedbackDto[], feedbackExpiryDate: string) {
    return this.mutation<boolean>(submitPmFeedbackRequest(), {pmId: pmId, feedbacks: feedbacks, feedbackExpiryDate: feedbackExpiryDate}, "submitPmFeedbackRequest")
  }

  public updatePmFeedbackExpiryDate(pmId: string, feedbackExpiryDate: string, isSelfReflection: boolean) {
    return this.mutation<boolean>(updatePmFeedbackExpiryDate(), {pmId: pmId, feedbackExpiryDate: feedbackExpiryDate, isSelfReflection: isSelfReflection}, "updatePmFeedbackExpiryDate")
  }
}
